export const ContentMaxWidth = 1400;
